import {
  boolean,
  index,
  integer,
  pgTable,
  text,
  uuid,
} from "drizzle-orm/pg-core";
import { createInsertSchema, createSelectSchema } from "drizzle-zod";
import { z } from "zod";

import { patientsTable } from "./patientsSchema";
import { customTimestamp } from "./utils/types";

export const npsSurveysTable = pgTable(
  "nps_surveys",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    patientId: uuid("patient_id")
      .references(() => patientsTable.id, { onDelete: "cascade" })
      .notNull(),
    score: integer("score").notNull(),
    feedback: text("feedback"),
    hasAllowedSharing: boolean("has_allowed_sharing").notNull().default(false),
    createdAt: customTimestamp("created_at")
      .notNull()
      .$defaultFn(() => new Date().toISOString()),
    updatedAt: customTimestamp("updated_at")
      .notNull()
      .$defaultFn(() => new Date().toISOString())
      .$onUpdateFn(() => new Date().toISOString()),
  },
  table => [index("nps_surveys_patient_id_index").on(table.patientId)],
);

export const npsSurveySchema = createSelectSchema(npsSurveysTable);
export type NpsSurveyType = z.infer<typeof npsSurveySchema>;

export const insertNpsSurveySchema = createInsertSchema(npsSurveysTable, {
  patientId: z.uuid(),
  score: z.number().int().min(0).max(10),
}).omit({
  createdAt: true,
  updatedAt: true,
});
export type InsertNpsSurveyType = z.infer<typeof insertNpsSurveySchema>;
